import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";

export const FloatingActions = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.5, duration: 0.5 }}
      className="fixed bottom-6 right-6 z-50"
    >
      <a
        href="https://wa.me/62822504050"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp-button"
        className="group flex items-center justify-center w-14 h-14 bg-[#25D366] hover:bg-[#20bd5a] text-white shadow-lg hover:shadow-xl transition-all duration-300"
      >
        <FaWhatsapp className="w-7 h-7 group-hover:scale-110 transition-transform" />
      </a>
      {/* Pulse Ring */}
      <span className="absolute inset-0 animate-ping bg-[#25D366]/30 pointer-events-none" />
    </motion.div>
  );
};

export default FloatingActions;
